import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ownerState"],
  _excluded2 = ["ownerState"],
  _excluded3 = ["ownerState"],
  _excluded4 = ["ownerState"];
import * as React from 'react';
import { ScrollArea } from '@base-ui/react/scroll-area';

// ---------------------------------------------------------------------------
// Thin wrappers that strip `ownerState` before forwarding to Base UI.
// `useSlotProps` adds `ownerState` for non‑string element types,
// but Base UI components would pass it through to the DOM.
// ---------------------------------------------------------------------------
import { jsx as _jsx } from "react/jsx-runtime";
export const ScrollRoot = /*#__PURE__*/React.forwardRef(function ScrollRoot(props, ref) {
  const other = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(ScrollArea.Root, _extends({}, other, {
    ref: ref
  }));
});
if (process.env.NODE_ENV !== "production") ScrollRoot.displayName = "ScrollRoot";
export const ScrollViewport = /*#__PURE__*/React.forwardRef(function ScrollViewport(props, ref) {
  const other = _objectWithoutPropertiesLoose(props, _excluded2);
  return /*#__PURE__*/_jsx(ScrollArea.Viewport, _extends({}, other, {
    ref: ref
  }));
});
if (process.env.NODE_ENV !== "production") ScrollViewport.displayName = "ScrollViewport";
export const ScrollScrollbar = /*#__PURE__*/React.forwardRef(function ScrollScrollbar(props, ref) {
  const other = _objectWithoutPropertiesLoose(props, _excluded3);
  return /*#__PURE__*/_jsx(ScrollArea.Scrollbar, _extends({}, other, {
    ref: ref
  }));
});
if (process.env.NODE_ENV !== "production") ScrollScrollbar.displayName = "ScrollScrollbar";
export const ScrollThumb = /*#__PURE__*/React.forwardRef(function ScrollThumb(props, ref) {
  const other = _objectWithoutPropertiesLoose(props, _excluded4);
  return /*#__PURE__*/_jsx(ScrollArea.Thumb, _extends({}, other, {
    ref: ref
  }));
});

// ---------------------------------------------------------------------------
// Shared default styles for scroll slots.
// Applied via `additionalProps` so consumers can override them through
// `slotProps` (which take higher priority in the `mergeSlotProps` order).
// ---------------------------------------------------------------------------
if (process.env.NODE_ENV !== "production") ScrollThumb.displayName = "ScrollThumb";
export const scrollbarStyle = {
  display: 'flex',
  justifyContent: 'center',
  boxSizing: 'border-box',
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0
};
export const thumbStyle = {
  flex: 1
};